import { api } from '$utils/api';
import type { stream } from 'garden-common';
import type { z } from 'zod';
import { handleAxiosError } from '../error-handler.util';

export type STREAM = z.infer<typeof stream>;

export async function setStream(data: STREAM): Promise<STREAM | null> {
  return await api
    .put('/v2/admin/stream/create', { data })
    .then(res => {
      return res.data.stream;
    })
    .catch(handleAxiosError);
}

export async function statusStream(isLive: STREAM['isLive']): Promise<STREAM | null> {
  return await api
    .put('/v2/admin/stream/live', { isLive })
    .then(res => {
      return res.data.stream;
    })
    .catch(handleAxiosError);
}

export async function getStream(): Promise<STREAM | null> {
  return await api
    .get(`/v2/admin/stream/get`)
    .then(res => {
      return res.data.stream;
    })
    .catch(handleAxiosError);
}

export async function delStream(): Promise<boolean> {
  return await api
    .delete(`/v2/admin/stream/delete`)
    .then(res => {
      return res.data.status;
    })
    .catch(handleAxiosError);
}
